import { create } from "zustand"

import { TEmailTemplateModal } from "~/types/accounts"

interface IChampionsTrackingStore {
  showMessageTemplateModal: TEmailTemplateModal | null
  setShowMessageTemplateModal: (value: TEmailTemplateModal | null) => void
  // Event-outreach: index of the last event-speaker template shown, so the
  // next open (re-roll) can ask the backend to pick a different one. Survives
  // across modal mounts since the modal is conditionally rendered.
  lastEventTemplateIndex: number | null
  setLastEventTemplateIndex: (value: number | null) => void
}

const useChampionsTrackingStore = create<IChampionsTrackingStore>((set) => ({
  showMessageTemplateModal: null,
  setShowMessageTemplateModal: (value) =>
    set({ showMessageTemplateModal: value }),
  lastEventTemplateIndex: null,
  setLastEventTemplateIndex: (value) => set({ lastEventTemplateIndex: value })
}))

export default useChampionsTrackingStore
